import React, { useContext } from 'react';
import ArtworldContext from './../../context/ArtworldContext';
import Select from 'react-select';
import { findSearchOption, aToZ } from './../../helpers';

const alphabet = aToZ()

const options = alphabet.map(letter => {
    return {
        value: letter,
        label: letter
    }
})

let optionsSelected = null

const PeopleAtoZ = () => {

    const context = useContext(ArtworldContext);

    const onChange = selectedOptions => {
        context.updateAdvancedSearch('people', 'person_name__start_with', selectedOptions && selectedOptions.value ? selectedOptions.value : '')
        optionsSelected = selectedOptions && selectedOptions.value ? selectedOptions.value : null
    };

    if (window.location.search) {
        optionsSelected = findSearchOption('people__person_name__start_with')
    }

    return (
        <div className="columns is-multiline is-variable">

            <div className="column is-full">

                Browse all entries by surname:

                <Select
                    value={options && optionsSelected ? options.filter(option => optionsSelected.includes(option.value)) : ''}
                    onChange={onChange}
                    options={options}
                    isClearable={true}
                />

            </div>
        </div>
    );
};

export default PeopleAtoZ;
